import {
  GETWAYTRANSACTIONLIST_SUCCESS,
  GETWAYTRANSACTIONLIST_FAILED,
  RESET_GETWAYTRANSACTIONLIST,
  LOADING_GETWAYTRANSACTIONLIST,
  NETWORK_ERROR_GETWAYTRANSACTIONLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETWAYTRANSACTIONLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETWAYTRANSACTIONLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETWAYTRANSACTIONLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETWAYTRANSACTIONLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETWAYTRANSACTIONLIST:
      return (state = initialState);
    default:
      return state;
  }
};
